import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class Contact extends Page{
    constructor(){
        super({
            id : 'contact',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}